/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMarketPilotTransactionLogListRequest model module.
 * @module model/LogControllerDtoMarketPilotTransactionLogListRequest
 * @version 1.0
 */
class LogControllerDtoMarketPilotTransactionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoMarketPilotTransactionLogListRequest</code>.
     * @alias module:model/LogControllerDtoMarketPilotTransactionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoMarketPilotTransactionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoMarketPilotTransactionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketPilotTransactionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketPilotTransactionLogListRequest} The populated <code>LogControllerDtoMarketPilotTransactionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketPilotTransactionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('sellerAccountNo')) {
                obj['sellerAccountNo'] = ApiClient.convertToType(data['sellerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketPilotTransactionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketPilotTransactionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoMarketPilotTransactionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

LogControllerDtoMarketPilotTransactionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['buyerAccountNo'] = undefined;

/**
 * @member {Number} sellerAccountNo
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['sellerAccountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketPilotTransactionLogListRequest.prototype['nftUid'] = undefined;






export default LogControllerDtoMarketPilotTransactionLogListRequest;

